import styled from 'styled-components'

const BREAKPOINT_MD = 960

export const ContentSection = styled.section`
  flex: 1;
  display: flex;
  justify-content: center;
  padding-bottom: 2rem;

  @media (max-width: ${BREAKPOINT_MD}px) {
    padding: 1rem;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-bottom: 20px;

  img {
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 5px;
  }
`

export const Description = styled.div`
  p {
    font-size: 15px;
    margin-bottom: 30px;
    text-align: center;
  }
`

export const ImageSection = styled.section`
  flex: 1;
  position: relative;

  @media (max-width: ${BREAKPOINT_MD}px) {
    height: 300px;
  }
`
export const MedicalRequestFormContainer = styled.div`
  width: 100%;
  max-width: 400px;
`

export const ErrorMessageContent = styled.div`
  margin-top: 1rem;
`
